import BotIndex from '@/views/bot/index.vue'
import BotDashboard from '@/views/bot/Dashboard.vue'
import BotNormalizador from '@/views/bot/Normalizador.vue'
import BotConvenios from '@/views/bot/Convenios.vue'
import BotPruebas from '@/views/bot/Pruebas.vue'
import BotConfiguraciones from '@/views/bot/Configuraciones.vue'
import BotRegistros from '@/views/bot/Registros.vue'
import BotTipificaciones from '@/views/bot/Tipificaciones.vue'
import BotChangeLog from '@/views/bot/ChangeLog.vue'
import BotWise from '@/views/bot/Wise.vue'

// Importar componentes de Coordinación
import CoordinacionDashboard from '@/views/bot/coordinacion/Dashboard.vue'
import CoordinacionRegistros from '@/views/bot/coordinacion/Registros.vue'
import CoordinacionConvenios from '@/views/bot/coordinacion/Convenios.vue'
import CoordinacionPruebas from '@/views/bot/coordinacion/Pruebas.vue'

// Importar componentes de Dispositivos Médicos
import DispositivosLayout from '@/views/bot/dispositivos-medicos/Layout.vue'
import DispositivosDashboard from '@/views/bot/dispositivos-medicos/Dashboard.vue'
import DispositivosRegistros from '@/views/bot/dispositivos-medicos/Registros.vue'
import DispositivosConvenios from '@/views/bot/dispositivos-medicos/Convenios.vue'
import DispositivosInventario from '@/views/bot/dispositivos-medicos/Inventario.vue'
import DispositivosMantenimiento from '@/views/bot/dispositivos-medicos/Mantenimiento.vue'
import DispositivosReportes from '@/views/bot/dispositivos-medicos/Reportes.vue'
import DispositivosPruebas from '@/views/bot/dispositivos-medicos/Pruebas.vue'



export default [
    {
        path: '/v2',
        component: BotIndex,
        meta: {
            requiresAuth: true,
            permiso: 'v2',
        },
        children: [
            {
                path: 'dashboard',
                name: 'bot-dashboard',
                component: BotDashboard,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Dashboard Bot'
                }
            },
            {
                path: 'registros',
                name: 'bot-registros',
                component: BotRegistros,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Registros'
                }
            },
            {
                path: 'normalizador',
                name: 'bot-normalizador',
                component: BotNormalizador,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Normalizador'
                }
            },
            {
                path: 'convenios',
                name: 'bot-convenios',
                component: BotConvenios,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Convenios'
                }
            },
            {
                path: 'tipificaciones',
                name: 'bot-tipificaciones',
                component: BotTipificaciones,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Tipificaciones'
                }
            },
            {
                path: 'pruebas',
                name: 'bot-pruebas',
                component: BotPruebas,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Pruebas'
                }
            },
            {
                path: 'configuraciones',
                name: 'bot-configuraciones',
                component: BotConfiguraciones,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Configuraciones'
                }
            },
            {
                path: 'changelog',
                name: 'bot-changelog',
                component: BotChangeLog,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Change Log'
                }
            },
            {
                path: 'wise',
                name: 'bot-wise',
                component: BotWise,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Wise'
                }
            },
            // Rutas de Coordinación
            {
                path: 'coordinacion/dashboard',
                name: 'coordinacion-dashboard',
                component: CoordinacionDashboard,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Dashboard Coordinación'
                }
            },
            {
                path: 'coordinacion/registros',
                name: 'coordinacion-registros',
                component: CoordinacionRegistros,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Registros Coordinación'
                }
            },
            {
                path: 'coordinacion/convenios',
                name: 'coordinacion-convenios',
                component: CoordinacionConvenios,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Convenios Coordinación'
                }
            },
            {
                path: 'coordinacion/pruebas',
                name: 'coordinacion-pruebas',
                component: CoordinacionPruebas,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Pruebas Coordinación'
                }
            },
            // Rutas de Dispositivos Médicos
            {
                path: 'dispositivos',
                component: DispositivosLayout,
                meta: {
                    requiresAuth: true,
                    permiso: 'v2',
                    title: 'Dispositivos Médicos'
                },
                children: [
                    {
                        path: 'dashboard',
                        name: 'dispositivos-dashboard',
                        component: DispositivosDashboard,
                        meta: {
                            requiresAuth: true,
                            permiso: 'v2',
                            title: 'Dashboard Dispositivos Médicos'
                        }
                    },
                    {
                        path: 'registros',
                        name: 'dispositivos-registros',
                        component: DispositivosRegistros,
                        meta: {
                            requiresAuth: true,
                            permiso: 'v2',
                            title: 'Registros Dispositivos Médicos'
                        }
                    },
                    {
                        path: 'convenios',
                        name: 'dispositivos-convenios',
                        component: DispositivosConvenios,
                        meta: {
                            requiresAuth: true,
                            permiso: 'v2',
                            title: 'Convenios Dispositivos Médicos'
                        }
                    },
                    {
                        path: 'inventario',
                        name: 'dispositivos-inventario',
                        component: DispositivosInventario,
                        meta: {
                            requiresAuth: true,
                            permiso: 'v2',
                            title: 'Inventario Dispositivos Médicos'
                        }
                    },
                    {
                        path: 'mantenimiento',
                        name: 'dispositivos-mantenimiento',
                        component: DispositivosMantenimiento,
                        meta: {
                            requiresAuth: true,
                            permiso: 'v2',
                            title: 'Mantenimiento Dispositivos Médicos'
                        }
                    },
                    {
                        path: 'reportes',
                        name: 'dispositivos-reportes',
                        component: DispositivosReportes,
                        meta: {
                            requiresAuth: true,
                            permiso: 'v2',
                            title: 'Reportes Dispositivos Médicos'
                        }
                    },
                    {
                        path: 'pruebas',
                        name: 'dispositivos-pruebas',
                        component: DispositivosPruebas,
                        meta: {
                            requiresAuth: true,
                            permiso: 'v2',
                            title: 'Pruebas Dispositivos Médicos'
                        }
                    }
                ]
            }
        ]
    }
] 